import { createRouter, createWebHistory } from 'vue-router'
import { RouteState } from './routeState';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      meta: { layout: 'empty' },
      component: () => import('../views/LoginView.vue')
    },
    {
      path: '/logout',
      name: 'logout',
      meta: { layout: 'empty' },
      component: () => import('../views/LogoutView.vue')
    },
    {
      path: '/theme',
      name: 'theme',
      meta: { layout: 'default' },
      children: [
        {
          path: 'main',
          name: 'theme-main',
          component: () => import('../views/theme/MainTheme.vue')
        },
        {
          path: 'icons',
          name: 'theme-icons',
          component: () => import('../views/theme/IconsTheme.vue')
        }
      ]
    },
    // Views no tamanho desktop
    {
      path: '/',
      name: 'home',
      meta: { layout: 'default' },
      component: () => import('../views/desktop/HomeView.vue')
    },
    {
      path: '/desktop/lista/:favoritos?',
      name: 'desktop-lista',
      meta: { layout: 'default' },
      component: () => import('../views/desktop/ListaDetalhadaView.vue'),      
    },
    {
      path: '/',
      name: 'desktop-empty',
      meta: { layout: 'empty' },
      children: [
        {
          path: 'detalhes/obra/:id?',
          name: 'desktop-detalhes-obra',
          component: () => import('../views/desktop/DetalhesObraView.vue')
        }
      ]
    },
    // Views no tamanho mobile
    {
      path: '/mobile',
      name: 'mobile-default',
      meta: { layout: 'default' },
      children: [
        {
          path: 'lista/:favoritos?',
          name: 'mobile-lista',
          component: () => import('../views/mobile/ListaView.vue')
        },
        {
          path: 'notificacoes',
          name: 'mobile-notificacoes',
          component: () => import('../views/mobile/NotificacoesView.vue')
        }
      ]
    },
    {
      path: '/mobile',
      name: 'mobile-empty',
      meta: { layout: 'empty' },
      children: [
        {
          path: 'detalhes/obra/:id?',
          name: 'mobile-detalhes-obra',
          component: () => import('../views/mobile/DetalhesObraView.vue')
        },
        {
          path: 'filtro',
          name: 'mobile-filtro',
          component: () => import('../views/mobile/FiltroView.vue'),
          meta: { layout: 'empty' },          
        },
        {
          path: 'historico/obra/:id?',
          name: 'mobile-historico-obra',
          component: () => import('../views/mobile/HistoricoObraView.vue')
        }
      ]
    }
  ]
})

const routeStore = new RouteState();

router.beforeEach(instance => {
  if (instance.name != null) {
    routeStore.checkRoute(instance.name.toString());
  }
});

export default router
